import { useTranslation } from 'react-i18next';

import { SkeletonText } from './Skeleton';

/**
 * Der Ladehinweis eines Bereichs.
 *
 * **Ein Skelett und kein kreisender Strich.** Der Strich sagt "warte"; das
 * Skelett sagt "hier kommt gleich Text" -- und reserviert dabei den Platz,
 * sodass die Seite beim Eintreffen der Daten nicht springt. Das Springen ist
 * der eigentliche Grund: Wer beim Laden schon auf eine Stelle zielt, klickt
 * nach dem Umbruch woanders hin.
 *
 * Der kreisende Strich bleibt trotzdem im Bestand -- als ``.spinner`` in der
 * Schaltflaeche, wo er hingehoert: Dort geht es um eine einzelne Handlung,
 * die unterwegs ist, und nicht um eine Flaeche, die sich fuellt.
 *
 * **Angesagt wird einmal.** Die Platzhalter selbst sind ``aria-hidden``; was
 * ein vorlesendes Programm hoert, ist der eine Satz darunter. Dreissig
 * Platzhalter, die einzeln "Grafik" melden, sind keine Auskunft.
 *
 * Ausdruecklich **ohne** ``role="status"``: Eine Seite hat in der Regel
 * genau einen Bereich, der Rueckmeldungen ansagt -- "Gespeichert", "Vielen
 * Dank". Traegt der Ladehinweis dieselbe Rolle, gibt es zwei, und die
 * Ansage der einen verdeckt die der anderen. Der Ladezustand steht
 * stattdessen an ``aria-busy``, dort, wo er hingehoert.
 */
export function LoadingIndicator({ lines = 4 }: { lines?: number } = {}) {
  const { t } = useTranslation();

  return (
    <div className="loading" aria-busy="true">
      <SkeletonText lines={lines} />
      <span className="visually-hidden">{t('app.loading')}</span>
    </div>
  );
}
